var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTarget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1,10c0,1.5-2.2,1.5-2.2,0S11.1,8.5,11.1,10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9,9.6C18.7,5,15,1.3,10.4,1.1V0H9.6v1.1C5,1.3,1.3,5,1.1,9.6H0v0.9h1.1         C1.3,15,5,18.7,9.6,18.9V20h0.9v-1.1c4.6-0.2,8.2-3.9,8.4-8.4H20V9.6H18.9z M18,9.6h-2.5c-0.2-2.7-2.4-4.9-5.1-5.1V2         C14.5,2.2,17.8,5.5,18,9.6z M14.6,10.4c-0.2,2.2-2,4-4.2,4.2v-2H9.6v2c-2.2-0.2-4-2-4.2-4.2h2V9.6h-2c0.2-2.2,2-4,4.2-4.2v2h0.9         v-2c2.2,0.2,4,2,4.2,4.2h-2v0.9H14.6z M9.6,2v2.5C6.8,4.7,4.7,6.8,4.5,9.6H2C2.2,5.5,5.5,2.2,9.6,2z M2,10.4h2.5         c0.2,2.7,2.4,4.9,5.1,5.1V18C5.5,17.8,2.2,14.5,2,10.4z M10.4,18v-2.5c2.7-0.2,4.9-2.4,5.1-5.1H18C17.8,14.5,14.5,17.8,10.4,18         L10.4,18z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.31224964.svg";
export { ForwardRef as ReactComponent };